import {Button} from "react-bootstrap";
import React from "react";
import * as Icon from 'react-bootstrap-icons';

function CancelButton(props: { visible: boolean, onClick: any }) {
  const {visible, onClick} = props;
  return <IconButton
    icon={<Icon.X/>}
    ariaLabel="Cancel"
    visible={visible}
    onClick={onClick}/>
}

function EditButton(props: { visible: boolean, onClick: any }) {
  const {visible, onClick} = props;
  return <IconButton
    icon={<Icon.Pencil/>}
    ariaLabel="Edit"
    visible={visible}
    onClick={onClick}/>
}

function SaveButton(props: { visible: boolean, onClick: any }) {
  const {visible, onClick} = props;
  return <IconButton
    icon={<Icon.Check/>}
    ariaLabel="Save"
    visible={visible}
    onClick={onClick}/>
}

function ViewButton(props: { visible: boolean, onClick: any }) {
  const {visible, onClick} = props;
  return <IconButton
    icon={<Icon.Eye/>}
    ariaLabel="Save"
    visible={visible}
    onClick={onClick}/>
}

function AddButton(props: { visible: boolean, onClick: any }) {
  const {visible, onClick} = props;
  return <IconButton
    icon={<Icon.Plus/>}
    ariaLabel="Add"
    visible={visible}
    onClick={onClick}/>
}

function ImageButton(props: { visible: boolean, onClick: any }) {
  const {visible, onClick} = props;
  return <IconButton
    icon={<Icon.Image/>}
    ariaLabel="Add Folder"
    visible={visible}
    onClick={onClick}/>
}

function FolderButton(props: { visible: boolean, onClick: any }) {
  const {visible, onClick} = props;
  return <IconButton
    icon={<Icon.Folder/>}
    ariaLabel="Add Folder"
    visible={visible}
    onClick={onClick}/>
}

function FolderAddButton(props: { visible: boolean, onClick: any }) {
  const {visible, onClick} = props;
  return <IconButton
    icon={<Icon.FolderPlus/>}
    ariaLabel="Add Folder"
    visible={visible}
    onClick={onClick}/>
}

function TrashButton(props: { visible: boolean, onClick: any }) {
  const {visible, onClick} = props;
  return <IconButton
    icon={<Icon.Trash/>}
    ariaLabel="Delete"
    visible={visible}
    onClick={onClick}/>
}

function XCircleButton(props: { visible: boolean, onClick: any }) {
  const {visible, onClick} = props;
  return <IconButton
    icon={<Icon.XCircle/>}
    ariaLabel="Delete"
    visible={visible}
    onClick={onClick}/>
}

function IconButton(props: {
  icon: any,
  visible: boolean,
  ariaLabel: string,
  onClick: any
}) {
  const {icon, visible, ariaLabel, onClick} = props;

  if (!visible) {
    return null
  }

  return (
    <Button type="button"
            size="sm"
            className="btn icon btn-secondary"
            aria-label={ariaLabel}
            onClick={onClick}>
      {icon}
    </Button>
  )
}

export {
  AddButton,
  CancelButton,
  EditButton,
  ImageButton,
  FolderButton,
  FolderAddButton,
  SaveButton,
  TrashButton,
  ViewButton,
  XCircleButton
};
